import { create } from "zustand";
import {
  subscribeWithSelector,
  persist,
  devtools,
  createJSONStorage,
} from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export interface IAlertHistory {
  symbol: string;
  timestamp: number;
  message: string;
  type: string;
}

interface AlertHistoryState {
  alerts: IAlertHistory[];
  setAlerts: (alerts: IAlertHistory[]) => void;
  addAlert: (alert: IAlertHistory) => void;
  removeAlert: (alert: IAlertHistory) => void;
  clearAlerts: () => void;
}

export const useAlertHistoryStore = create<AlertHistoryState>()(
  subscribeWithSelector(
    persist(
      devtools(
        immer((set) => ({
          alerts: [],
          addAlert: (alert: IAlertHistory) =>
            set((state: AlertHistoryState) => {
              state.alerts.push(alert);
            }),
          removeAlert: (alert: IAlertHistory) =>
            set((state: AlertHistoryState) => {
              state.alerts = state.alerts.filter(
                (a) => a.timestamp !== alert.timestamp,
              );
            }),
          setAlerts: (alerts: IAlertHistory[]) =>
            set((state: AlertHistoryState) => {
              state.alerts = alerts;
            }),
          clearAlerts: () =>
            set((state: AlertHistoryState) => {
              state.alerts = [];
            }),
        })),
      ),
      {
        name: "sf-alert-history-storage",
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
);
